export const IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST = 'IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST';
export const IMAGENES_ARTICULOS_OBTENER_IMAGENES_SUCCESS = 'IMAGENES_ARTICULOS_OBTENER_IMAGENES_SUCCESS';
export const IMAGENES_ARTICULOS_OBTENER_IMAGENES_FAILURE = 'IMAGENES_ARTICULOS_OBTENER_IMAGENES_FAILURE';
export const IMAGENES_ARTICULOS_OBTENER_IMAGENES_SET_LOADING = 'IMAGENES_ARTICULOS_OBTENER_IMAGENES_SET_LOADING';
export const IMAGENES_ARTICULOS_OBTENER_IMAGENES_SET_LOADED = 'IMAGENES_ARTICULOS_OBTENER_IMAGENES_SET_LOADED';
export const ARTICULOS_FILTROS_REQUEST = 'ARTICULOS_FILTROS_REQUEST';
export const ARTICULOS_FILTROS_SUCCESS = 'ARTICULOS_FILTROS_SUCCESS';
export const ARTICULOS_FILTROS_FAILURE = 'ARTICULOS_FILTROS_FAILURE';
